import {
  RIDER_APPLICATION_FETCH_ALL,
  RIDER_APPLICATION_FETCH_ONE,
  RIDER_APPLICATION_APPROVE,
  RIDER_APPLICATION_REJECT,
  RIDER_APPLICATION_RETURN,
  RIDER_APPLICATION_DISABLE,
  RIDER_APPLICATION_EDIT,
  RIDER_APPLICATION_DOWNLOAD,
} from 'src/api/routes';
import { MetadataResponse, SelectOption, SortParams } from './RiderApplicationDashboard.types';

export const RIDER_APP_DASHBOARD_FETCH_METADATA = 'RIDER_APP_DASHBOARD_FETCH_METADATA';
export const RIDER_APP_DASHBOARD_FETCH_METADATA_LOADING = 'RIDER_APP_DASHBOARD_FETCH_METADATA_LOADING';
export const RIDER_APP_DASHBOARD_FETCH_METADATA_ERROR = 'RIDER_APP_DASHBOARD_FETCH_METADATA_ERROR';

export const RIDER_APP_DASHBOARD_FETCH_APPLICATIONS = 'RIDER_APP_DASHBOARD_FETCH_APPLICATIONS';
export const RIDER_APP_DASHBOARD_FETCH_APPLICATIONS_LOADING = 'RIDER_APP_DASHBOARD_FETCH_APPLICATIONS_LOADING';
export const RIDER_APP_DASHBOARD_FETCH_APPLICATIONS_ERROR = 'RIDER_APP_DASHBOARD_FETCH_APPLICATIONS_ERROR';

export const RIDER_APP_DASHBOARD_SET_ACTIVE_TAB = 'RIDER_APP_DASHBOARD_SET_ACTIVE_TAB';
export const RIDER_APP_DASHBOARD_SET_APPLIED_FILTERS = 'RIDER_APP_DASHBOARD_SET_APPLIED_FILTERS';
export const RIDER_APP_DASHBOARD_SET_SORT = 'RIDER_APP_DASHBOARD_SET_SORT';
export const RIDER_APP_DASHBOARD_SET_PAGINATION = 'RIDER_APP_DASHBOARD_SET_PAGINATION';

export const RIDER_APP_DASHBOARD_FETCH_DETAIL = 'RIDER_APP_DASHBOARD_FETCH_DETAIL';
export const RIDER_APP_DASHBOARD_FETCH_DETAIL_LOADING = 'RIDER_APP_DASHBOARD_FETCH_DETAIL_LOADING';
export const RIDER_APP_DASHBOARD_FETCH_DETAIL_ERROR = 'RIDER_APP_DASHBOARD_FETCH_DETAIL_ERROR';
export const RIDER_APP_DASHBOARD_CLEAR_DETAIL = 'RIDER_APP_DASHBOARD_CLEAR_DETAIL';

export const RIDER_APP_DASHBOARD_APPROVE = 'RIDER_APP_DASHBOARD_APPROVE';
export const RIDER_APP_DASHBOARD_APPROVE_ERROR = 'RIDER_APP_DASHBOARD_APPROVE_ERROR';

export const RIDER_APP_DASHBOARD_REJECT = 'RIDER_APP_DASHBOARD_REJECT';
export const RIDER_APP_DASHBOARD_REJECT_ERROR = 'RIDER_APP_DASHBOARD_REJECT_ERROR';

export const RIDER_APP_DASHBOARD_RETURN = 'RIDER_APP_DASHBOARD_RETURN';
export const RIDER_APP_DASHBOARD_RETURN_ERROR = 'RIDER_APP_DASHBOARD_RETURN_ERROR';

export const RIDER_APP_DASHBOARD_EDIT_FORM = 'RIDER_APP_DASHBOARD_EDIT_FORM';
export const RIDER_APP_DASHBOARD_EDIT_FORM_ERROR = 'RIDER_APP_DASHBOARD_EDIT_FORM_ERROR';

export const RIDER_APP_DASHBOARD_EXPORT = 'RIDER_APP_DASHBOARD_EXPORT';
export const RIDER_APP_DASHBOARD_EXPORT_LOADING = 'RIDER_APP_DASHBOARD_EXPORT_LOADING';
export const RIDER_APP_DASHBOARD_EXPORT_ERROR = 'RIDER_APP_DASHBOARD_EXPORT_ERROR';

export const RIDER_APP_DASHBOARD_DISABLE = 'RIDER_APP_DASHBOARD_DISABLE';
export const RIDER_APP_DASHBOARD_DISABLE_ERROR = 'RIDER_APP_DASHBOARD_DISABLE_ERROR';

export const RIDER_APP_DASHBOARD_FETCH_BUCKET_COUNTS = 'RIDER_APP_DASHBOARD_FETCH_BUCKET_COUNTS';

export type DrawerTagPreset =
  | 'processing'
  | 'success'
  | 'error'
  | 'warning'
  | 'default';

export const STATUS_COLOR_MAP: Record<string, {
  colorKey: string;
  backgroundKey: string;
  borderKey: string;
  drawerLabel: string;
  drawerTagPreset: DrawerTagPreset;
}> = {
  in_progress: {
    colorKey: 'accent.blue.strong',
    backgroundKey: 'accent.blue.subtle',
    borderKey: 'accent.blue.muted',
    drawerLabel: 'In Progress',
    drawerTagPreset: 'default',
  },
  __pending_l1_approval: {
    colorKey: 'accent.orange.primary',
    backgroundKey: 'accent.orange.subtle',
    borderKey: 'accent.orange.muted',
    drawerLabel: 'Pending HR Approval',
    drawerTagPreset: 'default',
  },
  __pending_l2_approval: {
    colorKey: 'accent.orange.primary',
    backgroundKey: 'accent.orange.subtle',
    borderKey: 'accent.orange.muted',
    drawerLabel: 'Pending Ops Approval',
    drawerTagPreset: 'default',
  },
  rejected: {
    colorKey: 'accent.red.strong',
    backgroundKey: 'accent.red.subtle',
    borderKey: 'accent.red.muted',
    drawerLabel: 'Rejected',
    drawerTagPreset: 'error',
  },
  in_review: {
    colorKey: 'accent.blue.strong',
    backgroundKey: 'accent.blue.subtle',
    borderKey: 'accent.blue.muted',
    drawerLabel: 'In Review',
    drawerTagPreset: 'default',
  },
  completed: {
    colorKey: 'accent.green.primary',
    backgroundKey: 'accent.green.subtle',
    borderKey: 'accent.green.muted',
    drawerLabel: 'Approved',
    drawerTagPreset: 'success',
  },
  __pending_training: {
    colorKey: 'accent.orange.primary',
    backgroundKey: 'accent.orange.subtle',
    borderKey: 'accent.orange.muted',
    drawerLabel: 'Pending Training',
    drawerTagPreset: 'default',
  },
  __pending_promissory_note: {
    colorKey: 'accent.orange.primary',
    backgroundKey: 'accent.orange.subtle',
    borderKey: 'accent.orange.muted',
    drawerLabel: 'Pending Promissory Note',
    drawerTagPreset: 'default',
  },
  __returned_by_l1: {
    colorKey: 'accent.yellow.strong',
    backgroundKey: 'accent.yellow.subtle',
    borderKey: 'accent.yellow.soft',
    drawerLabel: 'HR Returned',
    drawerTagPreset: 'warning',
  },
  __returned_by_l2: {
    colorKey: 'accent.yellow.strong',
    backgroundKey: 'accent.yellow.subtle',
    borderKey: 'accent.yellow.soft',
    drawerLabel: 'Ops Returned',
    drawerTagPreset: 'warning',
  },
  __rejected_by_l1: {
    colorKey: 'accent.red.strong',
    backgroundKey: 'accent.red.subtle',
    borderKey: 'accent.red.muted',
    drawerLabel: 'HR Rejected',
    drawerTagPreset: 'error',
  },
  __rejected_by_l2: {
    colorKey: 'accent.red.strong',
    backgroundKey: 'accent.red.subtle',
    borderKey: 'accent.red.muted',
    drawerLabel: 'Ops Rejected',
    drawerTagPreset: 'error',
  },
  disabled: {
    colorKey: 'accent.red.strong',
    backgroundKey: 'accent.red.subtle',
    borderKey: 'accent.red.muted',
    drawerLabel: 'Disabled',
    drawerTagPreset: 'error',
  },
};

// A status with no event of its own reads the label of the event it aliases.
export const STATUS_EVENT_ALIASES: Record<string, string> = {
  completed: 'approved',
};

export const ACTIVITY_PILL_COLORS: Record<string, {
  colorKey: string;
  backgroundKey: string;
}> = {
  approved: {
    colorKey: 'accent.green.primary',
    backgroundKey: 'accent.green.subtle',
  },
  rejected: {
    colorKey: 'accent.red.strong',
    backgroundKey: 'accent.red.subtle',
  },
  returned: {
    colorKey: 'accent.yellow.strong',
    backgroundKey: 'accent.yellow.subtle',
  },
  edited: {
    colorKey: 'accent.purple.strong',
    backgroundKey: 'accent.purple.subtle',
  },
  created: {
    colorKey: 'text.tertiary',
    backgroundKey: 'background.neutral.subtle',
  },
  submitted: {
    colorKey: 'text.tertiary',
    backgroundKey: 'background.neutral.subtle',
  },
  trained: {
    colorKey: 'brand.default.primary',
    backgroundKey: 'brand.default.subtle',
  },
  pending: {
    colorKey: 'text.tertiary',
    backgroundKey: 'background.neutral.subtle',
  },
};

export const SEARCH_SCOPE_OPTIONS = [
  { label: 'Name', value: 'name' },
  { label: 'Phone', value: 'phone' },
  { label: 'Email', value: 'email' },
  { label: 'Application Number', value: 'application_number' },
  { label: 'Courier ID', value: 'worker_code' },
] as const;

export interface RiderApplicationColumn {
  key: string;
  title: string;
  dataIndex?: string;
  width: number;
  sorter?: boolean;
  defaultSortOrder?: 'ascend' | 'descend';
  fixed?: 'right' | 'left';
}

export const RIDER_APPLICATION_COLUMNS: RiderApplicationColumn[] = [
  { key: 'application_number', dataIndex: 'application_number', title: 'Application #', width: 180 },
  { key: 'applicant_name', dataIndex: 'applicant_name', title: 'Applicant Name', width: 200, sorter: true },
  { key: 'email', dataIndex: 'email', title: 'Email', width: 200 },
  { key: 'country', dataIndex: 'country', title: 'Country', width: 180 },
  { key: 'city_hub', title: 'City / Hub', width: 200 },
  { key: 'status', dataIndex: 'status', title: 'Application Status', width: 200 },
  { key: 'last_action', dataIndex: 'last_action', title: 'Last Action', width: 180 },
  { key: 'last_action_at', dataIndex: 'last_action_at', title: 'Last Action At', width: 180 },
  { key: 'last_action_by_name', dataIndex: 'last_action_by_name', title: 'Last Action By', width: 180 },
  { key: 'created_at', dataIndex: 'created_at', title: 'Created At', width: 180, sorter: true, defaultSortOrder: 'descend' },
  { key: 'submitted_at', dataIndex: 'submitted_at', title: 'Submitted At', width: 180, sorter: true },
  { key: 'worker_code', dataIndex: 'worker_code', title: 'Courier ID', width: 180 },
  { key: 'actions', title: 'Actions', width: 180, fixed: 'right' },
];

// Status filter fallback when the metadata has no lifecycle statuses; system statuses are excluded.
export const FALLBACK_STATUS_FILTER_IDS = [
  '__pending_l1_approval',
  '__returned_by_l1',
  '__rejected_by_l1',
  '__pending_training',
  '__pending_promissory_note',
  '__pending_l2_approval',
  '__returned_by_l2',
  '__rejected_by_l2',
  'completed',
] as const;

export const getRiderApplicationFilters = (statusOptions: SelectOption[]) => [
  {
    id: 'search',
    type: 'input',
    label: 'Search',
    placeholder: 'Search...',
    prefixSelectConfig: {
      id: 'search_by',
      default: 'name',
      placeholder: 'Search by',
      options: SEARCH_SCOPE_OPTIONS.map((opt) => ({ ...opt })),
    },
  },
  {
    id: 'created_at',
    type: 'date',
    mode: 'range',
    label: 'Created',
    placeholder: 'Created date range',
  },
  {
    id: 'hub_id',
    type: 'search',
    mode: 'multiple',
    label: 'Hub',
    placeholder: 'Hub',
    search_strategy: 'hub_search',
    threshold_length: 3,
  },
  {
    id: 'status',
    type: 'select',
    mode: 'multiple',
    label: 'Status',
    placeholder: 'All Statuses',
    options: statusOptions,
  },
];

export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [50, 100];
export const DEBOUNCE_DELAY = 500;

export const DEFAULT_SORT: SortParams = {
  field: 'created_at',
  order: 'desc',
};

// TODO(BE): replace with a metadata API once available.
// Field/document keys mirror the rider-side form (zajil-retail-booking
// AramexRiderApplicationForm/FormMetadata.js + AramexCountryConfig.json).
export const RIDER_APPLICATION_METADATA: MetadataResponse = {
  tabs: [
    {
      tab_key: 'personal',
      tab_header: 'Personal Info',
      fields: [
        // System-assigned, not applicant-supplied: the onboarded courier's Worker.worker_code,
        // linked once the application is approved; "—" until then.
        { column_id: 'worker_code', pretty_name: 'Courier ID', dataType: 'string' },
        { column_id: 'first_name', pretty_name: 'First Name', dataType: 'string' },
        { column_id: 'middle_name', pretty_name: 'Middle Name', dataType: 'string' },
        { column_id: 'last_name', pretty_name: 'Last Name', dataType: 'string' },
        //  Four parts, not the joined string: which token is first/father/grandfather/family is not recoverable from it.
        { column_id: 'arabic_name_1', pretty_name: 'First Name (Arabic)', dataType: 'string' },
        { column_id: 'arabic_name_2', pretty_name: 'Father Name (Arabic)', dataType: 'string' },
        { column_id: 'arabic_name_3', pretty_name: 'Grandfather Name (Arabic)', dataType: 'string' },
        { column_id: 'arabic_name_4', pretty_name: 'Family Name (Arabic)', dataType: 'string' },
        { column_id: 'dob', pretty_name: 'Date of Birth', dataType: 'date' },
        { column_id: 'email', pretty_name: 'Email', dataType: 'string' },
        { column_id: 'phone_number', pretty_name: 'Phone Number', dataType: 'string' },
        { column_id: 'is_vat_registered', pretty_name: 'VAT Registered', dataType: 'boolean' },
        { column_id: 'vat_registration_number', pretty_name: 'VAT Registration Number', dataType: 'string' },
        { column_id: 'country', pretty_name: 'Country', dataType: 'string' },
        { column_id: 'is_citizen', pretty_name: 'Citizen', dataType: 'boolean' },
        { column_id: 'national_id_number', pretty_name: 'National ID Number', dataType: 'string' },
        { column_id: 'national_id_expiry_date', pretty_name: 'ID Expiry Date', dataType: 'date' },
      ],
      uploaded_documents: [
        { key: 'profile_photo', label: 'Personal Photo', category: 'Profile' },
        { key: 'national_id_photos', label: 'National ID Photo', category: 'ID' },
        { key: 'criminal_record_document', label: 'Criminal Record', category: 'Criminal Record' },
      ],
    },
    {
      tab_key: 'location',
      tab_header: 'Location',
      fields: [
        { column_id: 'city', pretty_name: 'City', dataType: 'string' },
        { column_id: 'reporting_hub_id', pretty_name: 'Branch / Hub', dataType: 'string' },
      ],
    },
    {
      tab_key: 'vehicle',
      tab_header: 'Vehicle',
      fields: [
        { column_id: 'vehicle_type', pretty_name: 'Vehicle Type', dataType: 'string' },
        { column_id: 'vehicle_plate', pretty_name: 'Vehicle Plate Number', dataType: 'string' },
        { column_id: 'vehicle_reg_expiry', pretty_name: 'Vehicle Registration Expiry', dataType: 'date' },
        { column_id: 'driver_license_expiry', pretty_name: 'Driver License Expiry', dataType: 'date' },
      ],
      uploaded_documents: [
        { key: 'vehicle_reg_photo', label: 'Vehicle Registration', category: 'Vehicle' },
        { key: 'driver_license_photo', label: 'Driver License', category: 'License' },
      ],
    },
    {
      tab_key: 'compliance',
      tab_header: 'Compliance',
      fields: [
        { column_id: 'relative_works', pretty_name: 'Relative Works at Aramex', dataType: 'boolean' },
        { column_id: 'relative_name_1', pretty_name: "Relative's Employee Name 1", dataType: 'string' },
        { column_id: 'relative_name_2', pretty_name: "Relative's Employee Name 2", dataType: 'string' },
        { column_id: 'is_politician', pretty_name: 'Politically Exposed', dataType: 'boolean' },
        { column_id: 'was_aramex_employee', pretty_name: 'Was Aramex Employee', dataType: 'boolean' },
      ],
    },
    {
      tab_key: 'banking',
      tab_header: 'Banking',
      fields: [
        { column_id: 'full_account_holder_name', pretty_name: 'Account Holder Name', dataType: 'string' },
        { column_id: 'account_number', pretty_name: 'Account Number', dataType: 'string' },
        { column_id: 'bank_name', pretty_name: 'Bank Name', dataType: 'string' },
        { column_id: 'iban', pretty_name: 'IBAN', dataType: 'string' },
        { column_id: 'banking_address', pretty_name: 'Banking Address', dataType: 'string' },
      ],
    },
  ],
  field_config: [],
  permissions: {
    rider_application_approval_view: true,
    rider_application_disable: true,
  },
  is_disable_action_allowed: true,
};

export const TERMINAL_STATUSES = [
  'completed',
  'rejected',
  '__rejected_by_l1',
  '__rejected_by_l2',
  'disabled',
] as const;

export const RETURNED_STATUSES = [
  'in_review',
  '__returned_by_l1',
  '__returned_by_l2',
] as const;

export const API_ENDPOINTS = {
  FETCH_ALL: RIDER_APPLICATION_FETCH_ALL,
  FETCH_ONE: RIDER_APPLICATION_FETCH_ONE,
  APPROVE: RIDER_APPLICATION_APPROVE,
  REJECT: RIDER_APPLICATION_REJECT,
  RETURN: RIDER_APPLICATION_RETURN,
  DISABLE: RIDER_APPLICATION_DISABLE,
  EDIT: RIDER_APPLICATION_EDIT,
  DOWNLOAD: RIDER_APPLICATION_DOWNLOAD,
} as const;
